"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IERC165Upgradeable__factory = void 0;
var _ethers = require("ethers");
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

class IERC165Upgradeable__factory {
  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }
}
exports.IERC165Upgradeable__factory = IERC165Upgradeable__factory;
const _abi = [{
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];